import { Button, Col, Row } from 'react-bootstrap';

import { LoginCard } from '../../ui';
import React from 'react';
import { contentfulPropTypes } from '../../propTypes';
import electrifyDisc from '../../assets/svg/disc/electrify-disc.svg';
import generateDisc from '../../assets/svg/disc/generate-disc.svg';
import insulateDisc from '../../assets/svg/disc/insulate-disc.svg';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledWrapper = styled.div`
  .card {
    max-width: 800px;
  }
`;

const StyledH1 = styled.h1`
  max-width: 550px;
  margin: auto;

  @media (max-width: 575px) {
    font-size: 30px;
  }
`;

const StyledCol = styled(Col)`
  max-width: 350px;

  @media (max-width: 575px) {
    max-width: 100%;
  }
`;

const StyledButton = styled(Button)`
  max-width: 415px;
  margin: auto;
`;

const HowToWithLoopContainer = ({ contentful, loading, fetched }) => {
  const navigate = useNavigate();

  return (
    !loading &&
    fetched && (
      <StyledWrapper>
        <LoginCard>
          <StyledH1 className="pb-3">{contentful.title}</StyledH1>
          <p>{contentful.subtitle}</p>
          <Row className="justify-content-between">
            <StyledCol sm={4} className="px-4">
              <img className="mb-2" src={generateDisc} alt="Generate Icon" />
              <h3>{contentful.generateLabel}</h3>
              <p>{contentful.generateText}</p>
            </StyledCol>
            <StyledCol sm={4} className="px-4">
              <img className="mb-2" src={insulateDisc} alt="Insulate Icon" />
              <h3>{contentful.insulateLabel}</h3>
              <p>{contentful.insulateText}</p>
            </StyledCol>
            <StyledCol sm={4} className="px-4">
              <img className="mb-2" src={electrifyDisc} alt="Electrify Icon" />
              <h3>{contentful.electrifyLabel}</h3>
              <p>{contentful.electrifyText}</p>
            </StyledCol>
          </Row>
          <hr className="mx-2" />
          <p>{contentful.utilityText}</p>
          <StyledButton
            className="mb-0 mt-1 w-100"
            onClick={() => navigate('/net-zero/breakdown')}>
            {contentful.primaryButtonText}
          </StyledButton>
        </LoginCard>
      </StyledWrapper>
    )
  );
};

HowToWithLoopContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  HowToWithLoopContainer,
  'web_app_netzero_how_to_page',
  'netZeroHowTo',
);
